var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{domProps:{"value":_vm.value},on:{"input":function($event){return _vm.selectChange($event)}}},_vm._l((_vm.options),function(band,idx){return _c('option',{key:idx},[_vm._v(_vm._s(band))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }